export class HttpError extends Error {
  status: number;
  data: unknown;

  constructor(response: Response, data: unknown) {
    const message =
      typeof data === "object" &&
      data !== null &&
      "message" in data &&
      typeof data.message === "string"
        ? data.message
        : `Request failed with status ${response.status}`;

    super(message);
    this.name = "HttpError";
    this.status = response.status;
    this.data = data;
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}

export function isAuthRecoveryData(data: unknown): boolean {
  return (
    typeof data === "object" &&
    data !== null &&
    "error" in data &&
    (data as { error?: unknown }).error === "auth_recovery_required"
  );
}

/**
 * True for BFF auth-recovery 401s. Matches both HttpError (dashboard http-client)
 * and CoordinatorHttpError (ui-kit) since both carry `status` and `data`.
 * Callers should suppress competing error UI.
 */
export function isAuthRecoveryHttpError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  const e = error as { status?: unknown; data?: unknown };
  return e.status === 401 && isAuthRecoveryData(e.data);
}

export function getHttpErrorFields(error: HttpError): {
  name: string;
  message: string;
} {
  const d = error.data;
  const obj = typeof d === "object" && d !== null ? d : null;
  return {
    name: (obj as { name?: string } | null)?.name ?? error.name,
    message: (obj as { message?: string } | null)?.message ?? error.message,
  };
}
